import * as helper from '@/store/helpers'
import { defineStore } from 'pinia'

export const useRegionStore = defineStore('region', {
    state() {
        return {
            regions: [],
        }
    },
    getters: {
        region_names(state){
            return state.regions.map( region => region.name)
        },
        region_codes(state){
            return state.regions.map( region => region.code)
        },
        get_regions_personality(state){
            return state.regions.concat([{'name': 'Без региона', 'code': null}])
        },
        filter_region(state){
            return [{'name': 'Все', 'code': 'all'}].concat(state.regions).concat([{'name': 'Без региона', 'code': 'null'}])
        }
    },
    actions: {
        async getRegions() {
            let res = this.allNews = await helper.api('GET', '/region/region_list')
            if (res){
                this.regions=res
            }
        }
    }
})